import {
  contorno,
  FORMA_BADGE,
  pieno,
  type StatoTone,
} from "@/features/ordini/components/statoToni";

/** Colori di tipo e stato di una pratica reso/sostituzione. Una fonte sola per
 *  pagina Resi, pagina ordine e contesto della chat: lo stesso stato deve avere
 *  lo stesso colore ovunque, o a colpo d'occhio si leggono come cose diverse.
 *  Classi statiche, non concatenate, per non rompere il purge di Tailwind. */
// Redesign 27/10: forma e palette dei badge della lista ordini. Il tipo e'
// un'etichetta a CONTORNO, lo stato e' PIENO (chiuso: contorno, e' spento).
const KIND_BADGE: Record<string, { label: string; tono: StatoTone } | undefined> = {
  reso: { label: "Reso", tono: "sost-as" },
  sostituzione: { label: "Sostituzione", tono: "sost-fornitore" },
};

export const STATUS_BADGE: Record<
  string,
  { label: string; tono: StatoTone; pieno: boolean } | undefined
> = {
  // Richiesta presa al telefono: i colli arrivano col pronto merce, l'etichetta
  // si emette dopo. «Etichetta da fare» dice cosa manca, «Da emettere» no.
  richiesta: { label: "Etichetta da fare", tono: "ldv-mancante", pieno: true },
  etichetta_pronta: { label: "Etichetta pronta", tono: "in-corso", pieno: true },
  in_transito: { label: "In transito", tono: "spedito", pieno: true },
  consegnato: { label: "Consegnato", tono: "consegnata", pieno: true },
  chiuso: { label: "Chiuso", tono: "annullato", pieno: false },
  annullato: { label: "Annullato", tono: "annullato", pieno: true },
};

export function KindBadge({ kind }: { kind: string }) {
  const b = KIND_BADGE[kind] ?? { label: kind, tono: "annullato" as const };
  return (
    <span data-tono={b.tono} className={FORMA_BADGE} style={contorno(b.tono)}>
      {b.label}
    </span>
  );
}

export function StatusBadge({ status }: { status: string }) {
  // Uno stato futuro che il frontend non conosce si mostra grezzo, non sparisce.
  const b = STATUS_BADGE[status] ?? { label: status, tono: "annullato" as const, pieno: false };
  return (
    <span
      data-tono={b.tono}
      className={FORMA_BADGE}
      style={b.pieno ? pieno(b.tono) : contorno(b.tono)}
    >
      {b.label}
    </span>
  );
}
